var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { Typography } from '@material-ui/core';
const StyledParagraph = styled(Typography) `
  ${({ theme: { typography: { paragraph }, }, }) => `
    max-width: ${paragraph.maxWidth}px;
  `}
`;
/**
 *
 * API:
 *
 * - [Paragraph API](https://components-extra.netlify.app/components/paragraph)
 * - inherits [Typography API](https://material-ui.com/api/typography/)
 */
const Paragraph = (_a) => {
    var { color = 'textPrimary', forwardedRef, variant = 'body1' } = _a, rest = __rest(_a, ["color", "forwardedRef", "variant"]);
    return React.createElement(StyledParagraph, Object.assign({ color: color, variant: variant, ref: forwardedRef }, rest));
};
Paragraph.displayName = 'Paragraph';
const ParagraphExtra = styled(forwardRef((props, ref) => React.createElement(Paragraph, Object.assign({}, props, { forwardedRef: ref })))) ``;
export default ParagraphExtra;
